import { render, staticRenderFns } from "./dashboard-mdt.html?vue&type=template&id=bf4bae88&scoped=true&external"
import script from "./dashboard-mdt.js?vue&type=script&lang=js&external"
export * from "./dashboard-mdt.js?vue&type=script&lang=js&external"
import style0 from "./dashboard-mdt.scss?vue&type=style&index=0&id=bf4bae88&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4bae88",
  null
  
)

export default component.exports